import { useRequest } from 'features/request/useRequest';

import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { getWorkOrderSeasons } from '../WorkOrderChangeQueries';

export const useWorkOrderChangeSeasons = (workOrderChangeId: number, withEffect = true) => {
    const dispatch = useDispatch();

    const seasonsVariables = useMemo(() => ({ workOrderChangeId }), [workOrderChangeId]);

    const [workOrderChangeSeasonsData, , , getWorkOrderSeasonsData] = useRequest({
        requestId: 'workOrderChangeSeasons',
        query: getWorkOrderSeasons,
        variables: seasonsVariables,
        withEffect,
    });

    const refreshSeasonsDataHandler = useCallback(() => {
        dispatch(getWorkOrderSeasonsData(seasonsVariables));
    }, [dispatch, getWorkOrderSeasonsData, seasonsVariables]);

    return {
        seasons: workOrderChangeSeasonsData?.uerWorkOrderChangeSeasons?.items ?? [],
        refreshWorkOrderChangeSeasonsHandler: refreshSeasonsDataHandler,
    };
};
